import { KNOCK_UPDATE } from 'store/eventConstants';
import { NO_DEVICE_FOUND, PERMISSION_DENIED } from 'constants/ReadinessCheck';

/**
 * @description This will emit whenever director approves a knock
 * and presenter updates their details in AV modal either before
 * they join meeting or after they are already in meeting.
 */
function attendeeDetailsManager() {
  const { knock, meeting, readinessCheck } = this.store.getState();

  const { camera } = readinessCheck || {};
  const cameraUnavailable =
    camera === NO_DEVICE_FOUND || camera === PERMISSION_DENIED;

  const presenterDetailsUpdated = knock?.presenterDetailsUpdated;

  const shouldEmit = knock && !this._updatedKnock && presenterDetailsUpdated;

  const socketId = this?.socket?._socket?.id;

  const attendeeId = meeting?.attendeeResponse?.Attendee?.AttendeeId;

  // Presenter populates details in AV modal before joining the meeting
  if (shouldEmit) {
    this._updatedKnock = {
      ...knock,
      socketId,
      attendeeId,
      cameraUnavailable
    };

    this.socket.emit(KNOCK_UPDATE, this._updatedKnock);
  }

  // Presenter clicked on settings and updated details after joining the meeting
  if (knock && this._updatedKnock) {
    const { name, description } = knock;
    const nameEdited = name !== this._updatedKnock?.name;
    const descriptionEdited = description !== this._updatedKnock?.description;

    if (nameEdited || descriptionEdited) {
      this._updatedKnock = {
        ...knock,
        socketId,
        attendeeId
      };

      this.socket.emit(KNOCK_UPDATE, this._updatedKnock);
    }
  }
}

export default attendeeDetailsManager;
